export const urlQueryBuilder = (params: Record<string, any>) => {
  const queryString = new URLSearchParams();

  // Iterate over the object and append non-null values to the query string
  for (const key in params) {
    const value = params[key];
    if (value === null || value === undefined || value === "") {
      continue;
    }

    // Convert value to string and handle special cases
    let stringValue: string;
    if (typeof value === "number") {
      stringValue = value.toString();
    } else if (typeof value === "boolean") {
      stringValue = value.toString();
    } else {
      stringValue = String(value);
    }

    queryString.append(key, stringValue);
  }

  return queryString.toString();
};
